import { Injectable } from '@angular/core';
import { ApiConstants } from '../constants/api-constants';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { ApiResponse } from 'src/models/api-response.model';

@Injectable({
  providedIn: 'root'
})
export class UsersService {

  session_token: any;
  URL_COMM = ApiConstants.URL_USERS;
  URL_ROLES = ApiConstants.URL_ROLES;

  constructor(private http: HttpClient) { }

  async getUsers(): Promise<any> {
    let URL = this.URL_COMM;
    const response = await firstValueFrom(
      this.http.get<any>(URL)
    );
    return response.data;
  }

  async getUserById(id: string): Promise<any> {
    if (!id) {
      throw new Error('User id is required');
    }

    const URL = `${this.URL_COMM}/${id}`;
    try {
      const response = await firstValueFrom(this.http.get<any>(URL));
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  async addUser(body: any): Promise<any> {
    const URL = `${this.URL_COMM}`;
    try {
      const response = await firstValueFrom(this.http.post<any>(URL, body));
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  async editUser(id: string, body: any): Promise<ApiResponse> {
    let URL = `${this.URL_COMM}/${id}`;
    try {
      const response = await firstValueFrom(this.http.patch<any>(URL, body));
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  private handleError(error: any): Error {
    // Assuming the error structure is consistent and always has the `errorMessages` array
    const errorMessage = error.error?.errorMessages?.length > 0
      ? error.error.errorMessages[0].message
      : 'Unknown error occurred';
    return new Error(errorMessage);
  }

  async deleteUser(id: string): Promise<ApiResponse> {
    let URL = `${this.URL_COMM}/${id}`;
    const response = await firstValueFrom(
      this.http.delete<any>(URL)
    );
    return response.data;
  }

  async getRoles(): Promise<any> {
    let URL = `${this.URL_ROLES}`;
    const response = await firstValueFrom(
      this.http.get<any>(URL)
    );
    return response.data;
  }

}
